import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && (error.message || String(error))) || 'Error' };
  }

  componentDidCatch(error, info) {
    try { console.error('UI error boundary:', error, info); } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 8, border: '1px solid #eee', borderRadius: 6, background: '#fffbe6', color: '#8a6d3b' }}>
          {this.props.fallback || 'Ha ocurrido un error al renderizar esta sección.'}
        </div>
      );
    }
    return this.props.children;
  }
}

